module.exports = __webpack_public_path__ + "static/media/laser-ripple.893a40cb.gif";